import { z } from 'zod'
import type UserFilteringData from '../../common/server/api/v2/filters/index.get'

export const UserFilteringSchema = z.object({
  userAgent: z.string().nullable(),
  countryCode: z.string(),
  isMobile: z.boolean().default(false),
  nativeProvider: z.enum(['outbrain', 'taboola']).default('outbrain'),
})

export type UserFilteringData = z.infer<typeof UserFilteringSchema>

const defaultUserFilteringData = UserFilteringSchema.parse({
  countryCode: 'US',
  userAgent: null,
})

/**
 * Fetches user filtering data from the server and provides it to the Nuxt app.
 */
export default defineNuxtPlugin(async (nuxtApp) => {
  try {
    const url = `/api/v2/filters`
    const userGeoData = await $fetch<UserFilteringData>(url)
    const { OpenFeature } = await import('@openfeature/web-sdk')
    OpenFeature.setContext({
      country: userGeoData.countryCode,
      userAgent: userGeoData.userAgent,
      isMobile: userGeoData.isMobile,
      nativeProvider: userGeoData.nativeProvider,
    })
    const filters = {
      ...userGeoData,
      // this may change to be FF controlled or overwritten
      nativeProvider: userGeoData.countryCode === 'US' ? 'outbrain' : 'taboola',
      isMobile: userGeoData.userAgent?.includes('Mobile') || false,
    }

    const parsedFilters = UserFilteringSchema.safeParse(filters)
    if (!parsedFilters.success) {
      console.warn('Invalid user filtering data:', parsedFilters.error)
      nuxtApp.provide('filters', defaultUserFilteringData)
      return
    }

    nuxtApp.provide('filters', parsedFilters.data)
  } catch (error) {
    console.warn('Error fetching user filtering data:', error)
    nuxtApp.provide('filters', defaultUserFilteringData)
  }
})
